import FetchError from '../types/http';
import log from './log';

export const handleFetchError = (
  error: Error | FetchError,
  service: string = 'unknown',
): FetchError => {
  log.error(`Error from fetch request, service: ${service}`, error.message);
  if ('status' in error) {
    return error;
  }
  return { ...error, status: 500 };
};
